import { __decorate, __extends } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue-ltur';
import { FilterType } from "./BaseFilterInterface";
import BaseFilterBar from "FilterBar/BaseFilterBar/Base/BaseFilterBar";
import Analytics from "Helper/Analytics";
var BaseFilter = /** @class */ (function (_super) {
    __extends(BaseFilter, _super);
    function BaseFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BaseFilter.prototype, "type", {
        get: function () {
            return FilterType.BASE_FILTER;
        },
        enumerable: false,
        configurable: true
    });
    BaseFilter.prototype.created = function () {
        this.initializeModel();
    };
    BaseFilter.prototype.initializeModel = function () {
        this.previousModel = JSON.parse(JSON.stringify(this.initialValue));
        this.currentModel = JSON.parse(JSON.stringify(this.initialValue));
    };
    BaseFilter.prototype.toJSON = function () {
        return {
            model: this.currentModel,
            previousModel: this.previousModel,
            identifier: this.identifier,
            initialValue: this.initialValue,
            type: this.type
        };
    };
    BaseFilter.prototype.equals = function (state) {
        return JSON.stringify(state) === JSON.stringify(this.currentModel);
    };
    BaseFilter.prototype.isFilterModified = function () {
        return JSON.stringify(this.initialValue) !== JSON.stringify(this.currentModel);
    };
    BaseFilter.prototype.reset = function (emitChange) {
        if (emitChange === void 0) { emitChange = false; }
        if (!this.isFilterModified())
            return;
        this.changeValue(this.initialValue, emitChange);
    };
    BaseFilter.prototype.setPrevious = function () {
        if (this.equals(this.previousModel))
            return;
        this.changeValue(this.previousModel);
    };
    BaseFilter.prototype.setFilter = function (value, emitChange) {
        if (emitChange === void 0) { emitChange = false; }
        if (this.equals(value))
            return;
        this.changeValue(value, emitChange);
    };
    BaseFilter.prototype.registrateFilter = function () {
        var filterBar = this.findFilterBarRecurse();
        if (filterBar)
            filterBar.pushFilter(this);
    };
    BaseFilter.prototype.findFilterBarRecurse = function (component) {
        if (component === void 0) { component = this; }
        if (component.$parent && component.$parent instanceof BaseFilterBar) {
            return component.$parent;
        }
        if (!component.$parent)
            return null;
        return this.findFilterBarRecurse(component.$parent);
    };
    BaseFilter.prototype.changeValue = function (value, emitChange) {
        if (emitChange === void 0) { emitChange = false; }
        this.previousModel = JSON.parse(JSON.stringify(this.currentModel));
        this.currentModel = JSON.parse(JSON.stringify(value));
        this.$emit('dispatchFilter', this.toJSON());
        if (emitChange && this.track && this.analytics)
            Analytics.trackFilterChange(JSON.parse(JSON.stringify(this)));
        if (emitChange) {
            this.$emit('changeValue', this.toJSON());
        }
        this.$forceUpdate();
    };
    __decorate([
        Prop({ default: true })
    ], BaseFilter.prototype, "track", void 0);
    __decorate([
        Prop({ default: true })
    ], BaseFilter.prototype, "analytics", void 0);
    __decorate([
        Prop()
    ], BaseFilter.prototype, "initialValue", void 0);
    __decorate([
        Prop()
    ], BaseFilter.prototype, "identifier", void 0);
    BaseFilter = __decorate([
        Component
    ], BaseFilter);
    return BaseFilter;
}(Vue));
export default BaseFilter;
